import Vue from 'vue';
import axios from 'axios';

export default Vue.extend({
  template: `<span v-tooltip="{ content: tagNames, classes: ['info'], targetClasses: ['it-has-a-tooltip'] }" :class="{'font-bold cursor-pointer' : displayValue}" @click="fetchTagNames(displayValue)">{{displayValue}}</span>`,
  data: function() {
    return {
      displayValue: '',
      tagNames: ''
    };
  },
  beforeMount() {
    this.displayValue = this.params.value;
  },
  methods: {
    async fetchTagNames(data) {
      this.tagNames = '';
      if (data) {
        let tagStat = await axios.post('/leads-tag-name', {
          lead_id: this.params.data.id.lead_id
        });
        if (
          tagStat &&
          tagStat.data &&
          tagStat.data.tag_names &&
          tagStat.data.tag_names.length
        ) {
          let index = 0;
          tagStat.data.tag_names.forEach(ele => {
            if (index == tagStat.data.tag_names.length - 1) {
              this.tagNames += `<p>${ele}</p>`;
            } else {
              this.tagNames += `<p>${ele}</p><br/>`;
            }
            index++;
          });
        }
      }
    }
  }
});
